import React from 'react';
import { cn } from '@/lib/utils';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  text,
  href,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'bg-[#BE19BE] hover:bg-[#A015A0] text-white font-bold rounded-lg transform hover:scale-105 transition-all duration-200 inline-block text-center shadow-[0_0_20px_rgba(190,25,190,0.5),0_0_40px_rgba(190,25,190,0.3),0_0_60px_rgba(190,25,190,0.15)] hover:shadow-[0_0_25px_rgba(190,25,190,0.7),0_0_50px_rgba(190,25,190,0.4),0_0_80px_rgba(190,25,190,0.2)] animate-cta-wiggle';
  const sizeClasses = size === 'large' ? 'px-8 py-4 text-base md:text-lg' : 'px-5 py-2.5 text-sm md:text-base';
  if (href) {
    return <a href={href} className={cn(`${baseClasses} ${sizeClasses} ${className}`)} target="_blank" rel="noopener noreferrer" data-id="element-37" data-mp="3cqdq6bcfk2z6">
        {text}
      </a>;
  }
  return null;
}